// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobileMenuOverlay_hhCA_ {
  position: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--_00000020-background);
  z-index: 99999999999;
}

.mobileMenu_Ir3Ox {
  z-index: 99999999999999999999999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;
  gap: 10px;
  position: fixed;
  top: 0px;
  left: -100vw;
  width: 240px;
  background-color: var(--white-background);
  height: 100vh;
  transition: left 300ms;
  padding: 10px;
  border-left: 1px solid var(--f5-background);
  -webkit-transition: left 300ms;
  -moz-transition: left 300ms;
  -ms-transition: left 300ms;
  -o-transition: left 300ms;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    gap: 14px;
    width: 100%;
    box-sizing: border-box;
    margin: 0;
    padding: 10px;

    li,
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      text-decoration: none;
      color: var(--_2-color);

      svg {
        width: 15px;
        height: 15px;
        fill: var(--white-color);
      }

      .bigger_OLWWL {
        svg {
          height: 18px;
          width: 18px;
        }
      }
    }
    li {
      justify-content: start;
      width: 100%;
    }
    .active_AJXLd {
      .svgContainer_mX86J{
        background-color: var(--_073f31-background);
      }
      svg {
      }
    }
  }
  .svgContainer_mX86J {
    width: 35px;
    height: 35px;
    min-width: 35px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--_10a37f-border);
    color: var(--white-color);
    font-size: 20px;
    font-weight: 600;
  }
  .profileContainer_F69gK {
    align-items: flex-end;
    display: flex;
    align-items: center;
    gap: 10px;
    .profileImage_Ll5NL{
      max-width: 40px;
      width: 40px;
      height: 40px;
      border-radius: 999px;
      -webkit-border-radius: 999px;
      -moz-border-radius: 999px;
      -ms-border-radius: 999px;
      -o-border-radius: 999px;
}
    p {
      font-size: 15px;
      margin: 0;
    }
    span {
      font-size: 10px;
    }
    .initials_Ad2pz {
      width: 35px;
      height: 35px;
      min-width: 35px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--_10a37f-background);
      color: var(--white-color);
      font-size: 20px;
      font-weight: 600;
    }
  }

  .options_gctX9 {

  z-index: 3;
  padding: 4px;

  ul {
    margin: 0;
    display: flex;
    flex-direction: column;
    padding: 0;

    li {
      margin: 0;
      list-style: none;
      display: flex;
      align-items: center;
      gap: 10px;
      color: var(--_3-color);
      box-sizing: border-box;
      width: 100%;
      padding: 8px;
      border: none;
      background: none;
      text-align: left;
      cursor: pointer;
      font-size: 14px;
      border-radius: 4px;
      transition: background-color 0.2s ease-in-out;
      -webkit-transition: background-color 0.2s ease-in-out;
      -moz-transition: background-color 0.2s ease-in-out;
      -ms-transition: background-color 0.2s ease-in-out;
      -o-transition: background-color 0.2s ease-in-out;

      &.upgradePlan_ul9lk {
        background: var(--e4fff9-background);
      }

      &:hover {
        background-color: var(--f5-background);
      }

      svg {
        color: var(--_0d-color);
        fill: var(--_0d-color);
      }
    }
  }
}
}
.activeMenuOverlay_vgU07 {
  position: fixed;
}
.activeMobileMenu_An8yY {
  left: 0;
}

.fileExplorerGetPlusContainer_YMAvS {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.moreGreen_jY32k {
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  cursor: pointer;
  background: var(--white-background);
  width: 40px;
  height: 40px;
  border: 2px solid var(--ca-border);
  border-radius: 999px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  position: relative;
}
.moreGreen_jY32k svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); 
  width: 20px; 
  height: 20px; 
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NavbarAdmin/MobileAsidebarNavigation/MobileAsidebarNavigation.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,2CAA2C;EAC3C,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;IAET;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,aAAa;;IAEb;;MAEE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,qBAAqB;MACrB,sBAAsB;;MAEtB;QACE,WAAW;QACX,YAAY;QACZ,wBAAwB;MAC1B;;MAEA;QACE;UACE,YAAY;UACZ,WAAW;QACb;MACF;IACF;IACA;MACE,sBAAsB;MACtB,WAAW;IACb;IACA;MACE;QACE,2CAA2C;MAC7C;MACA;MACA;IACF;EACF;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,yBAAyB;IACzB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT;MACE,eAAe;MACf,WAAW;MACX,YAAY;MACZ,oBAAoB;MACpB,4BAA4B;MAC5B,yBAAyB;MACzB,wBAAwB;MACxB,uBAAuB;AAC7B;IACI;MACE,eAAe;MACf,SAAS;IACX;IACA;MACE,eAAe;IACjB;IACA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,qCAAqC;MACrC,yBAAyB;MACzB,eAAe;MACf,gBAAgB;IAClB;EACF;;EAEA;;EAEA,UAAU;EACV,YAAY;;EAEZ;IACE,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,UAAU;;IAEV;MACE,SAAS;MACT,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,sBAAsB;MACtB,sBAAsB;MACtB,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,gBAAgB;MAChB,gBAAgB;MAChB,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,6CAA6C;MAC7C,qDAAqD;MACrD,kDAAkD;MAClD,iDAAiD;MACjD,gDAAgD;;MAEhD;QACE,oCAAoC;MACtC;;MAEA;QACE,sCAAsC;MACxC;;MAEA;QACE,uBAAuB;QACvB,sBAAsB;MACxB;IACF;EACF;AACF;AACA;AACA;EACE,eAAe;AACjB;AACA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;AACd","sourcesContent":[".mobileMenuOverlay {\n  position: none;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--_00000020-background);\n  z-index: 99999999999;\n}\n\n.mobileMenu {\n  z-index: 99999999999999999999999;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: start;\n  gap: 10px;\n  position: fixed;\n  top: 0px;\n  left: -100vw;\n  width: 240px;\n  background-color: var(--white-background);\n  height: 100vh;\n  transition: left 300ms;\n  padding: 10px;\n  border-left: 1px solid var(--f5-background);\n  -webkit-transition: left 300ms;\n  -moz-transition: left 300ms;\n  -ms-transition: left 300ms;\n  -o-transition: left 300ms;\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n\n    svg {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  ul {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    justify-content: start;\n    gap: 14px;\n    width: 100%;\n    box-sizing: border-box;\n    margin: 0;\n    padding: 10px;\n\n    li,\n    a {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 10px;\n      text-decoration: none;\n      color: var(--_2-color);\n\n      svg {\n        width: 15px;\n        height: 15px;\n        fill: var(--white-color);\n      }\n\n      .bigger {\n        svg {\n          height: 18px;\n          width: 18px;\n        }\n      }\n    }\n    li {\n      justify-content: start;\n      width: 100%;\n    }\n    .active {\n      .svgContainer{\n        background-color: var(--_073f31-background);\n      }\n      svg {\n      }\n    }\n  }\n  .svgContainer {\n    width: 35px;\n    height: 35px;\n    min-width: 35px;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--_10a37f-border);\n    color: var(--white-color);\n    font-size: 20px;\n    font-weight: 600;\n  }\n  .profileContainer {\n    align-items: flex-end;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    .profileImage{\n      max-width: 40px;\n      width: 40px;\n      height: 40px;\n      border-radius: 999px;\n      -webkit-border-radius: 999px;\n      -moz-border-radius: 999px;\n      -ms-border-radius: 999px;\n      -o-border-radius: 999px;\n}\n    p {\n      font-size: 15px;\n      margin: 0;\n    }\n    span {\n      font-size: 10px;\n    }\n    .initials {\n      width: 35px;\n      height: 35px;\n      min-width: 35px;\n      border-radius: 5px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: var(--_10a37f-background);\n      color: var(--white-color);\n      font-size: 20px;\n      font-weight: 600;\n    }\n  }\n\n  .options {\n\n  z-index: 3;\n  padding: 4px;\n\n  ul {\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n\n    li {\n      margin: 0;\n      list-style: none;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      color: var(--_3-color);\n      box-sizing: border-box;\n      width: 100%;\n      padding: 8px;\n      border: none;\n      background: none;\n      text-align: left;\n      cursor: pointer;\n      font-size: 14px;\n      border-radius: 4px;\n      transition: background-color 0.2s ease-in-out;\n      -webkit-transition: background-color 0.2s ease-in-out;\n      -moz-transition: background-color 0.2s ease-in-out;\n      -ms-transition: background-color 0.2s ease-in-out;\n      -o-transition: background-color 0.2s ease-in-out;\n\n      &.upgradePlan {\n        background: var(--e4fff9-background);\n      }\n\n      &:hover {\n        background-color: var(--f5-background);\n      }\n\n      svg {\n        color: var(--_0d-color);\n        fill: var(--_0d-color);\n      }\n    }\n  }\n}\n}\n.activeMenuOverlay {\n  position: fixed;\n}\n.activeMobileMenu {\n  left: 0;\n}\n\n.fileExplorerGetPlusContainer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n.moreGreen {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  background: var(--white-background);\n  width: 40px;\n  height: 40px;\n  border: 2px solid var(--ca-border);\n  border-radius: 999px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  position: relative;\n}\n.moreGreen svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); \n  width: 20px; \n  height: 20px; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileMenuOverlay": `mobileMenuOverlay_hhCA_`,
	"mobileMenu": `mobileMenu_Ir3Ox`,
	"bigger": `bigger_OLWWL`,
	"active": `active_AJXLd`,
	"svgContainer": `svgContainer_mX86J`,
	"profileContainer": `profileContainer_F69gK`,
	"profileImage": `profileImage_Ll5NL`,
	"initials": `initials_Ad2pz`,
	"options": `options_gctX9`,
	"upgradePlan": `upgradePlan_ul9lk`,
	"activeMenuOverlay": `activeMenuOverlay_vgU07`,
	"activeMobileMenu": `activeMobileMenu_An8yY`,
	"fileExplorerGetPlusContainer": `fileExplorerGetPlusContainer_YMAvS`,
	"moreGreen": `moreGreen_jY32k`
};
export default ___CSS_LOADER_EXPORT___;
